import { render, staticRenderFns } from "./NameCard.vue?vue&type=template&id=031c2a2d&scoped=true&"
import script from "./NameCard.vue?vue&type=script&lang=js&"
export * from "./NameCard.vue?vue&type=script&lang=js&"
import style0 from "./NameCard.vue?vue&type=style&index=0&id=031c2a2d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031c2a2d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBottomNav } from 'vuetify/lib/components/VBottomNav';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VAvatar,VBottomNav,VBtn,VCard,VCardText,VFlex,VIcon,VLayout,VResponsive})
